const { registerBlockType } = wp.blocks;
const { RichText } = wp.blockEditor;
const { RawHTML } = wp.element;

registerBlockType('mailmetrics/custom-html', {
  title: 'Mailmetrics Custom HTML Block',
  icon: 'media-text',
  category: 'layout',
  attributes: {
    content: {
      type: 'string',
      source: 'html',
      selector: 'div',
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { content } = attributes;

    return (
      <RichText
        tagName="div"
        value={content}
        onChange={(newContent) => setAttributes({ content: newContent })}
        placeholder="Enter HTML content..."
        multiline="p"
        keepPlaceholderOnFocus
      />
    );
  },
  save: ({ attributes }) => {
    return <RawHTML>{attributes.content}</RawHTML>;
  }

});
